import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-management-page',
  templateUrl: './management-page.component.html',
  styleUrls: ['./management-page.component.scss']
})
export class ManagementPageComponent implements OnInit {
  feedbackForm: FormGroup = new FormGroup({
    email: new FormControl(),
    mobile: new FormControl(),
    message: new FormControl(),
  })

  constructor(private http: HttpClient) { }
  submitFeedback() {
    let { value: feedbackForm } = this.feedbackForm;
    this.http.post(`mail_helper.php`, feedbackForm).subscribe(data => {

    }, err => {

      // console.log("errrrrrrrrrrrrr",err);
    })
    this.feedbackForm.reset();


  }

  ngOnInit() {
  }

}
